export interface IItemLocation {
	code: number;
	itemCode: number;
	huntChicken: number;
	huntBat: number;
	huntBoar: number;
	huntWildDog: number;
	huntWolf: number;
	huntBear: number;
	huntWickline: number;
	collectibleCode: number;
	airSupply: number;
}
